<template>
  <div>
    <v-progress-linear
      v-if="loading"
      class="mt-2"
      indeterminate
      background-color="primary"
    ></v-progress-linear>
    <template v-else>
      <v-text-field
        class="mt-3"
        label="Pesquisar produto"
        v-model="pesquisaModel"
        append-icon="mdi-magnify"
        v-if="!isMobile()"
      ></v-text-field>
      <template v-if="isMobile()">
        <v-alert
          v-if="produtosFiltrados().length == 0"
          class="body-2"
          type="info"
          text
        >
          Nenhum produto localizado
        </v-alert>

        <template v-for="(prod, i) in produtosFiltrados()">
          <dialog-adicionar-produto-inumos :key="i" :produto="prod">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ prod.descricao }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-chip x-small> {{ prod.embalagem }}</v-chip> ({{
                  prod.grupo
                }}
                - {{ prod.subgrupo }}-{{ prod.item }})
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <p class="mt-2 mb-1">
                  Saldo na filial: {{ getSaldoProduto(prod, "filial") }}
                </p>
                <p class="mb-0">
                  Saldo pronta entrega: {{ getSaldoProduto(prod, "imediato") }}
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="font-weight-bold subtitle-1">
              {{
                pedido_item.cliente.socio
                  ? formatarMoeda(prod.valor_lista)
                  : formatarMoeda(prod.valor_lista_nao_socio)
              }}
            </v-list-item-action>
          </dialog-adicionar-produto-inumos>
        </template>

        <!--<v-list-item
          class="grey lighten-5 mt-2"
          three-line
        
          :key="i"
          @click="selecionarProduto(prod)"          
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ prod.descricao }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-chip x-small> {{ prod.embalagem }}</v-chip> ({{ prod.grupo }} -
              {{ prod.subgrupo }}-{{ prod.item }})
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <p class="mt-2 mb-1">
                Saldo na filial: {{ getSaldoProduto(prod, "filial") }}
              </p>
              <p class="mb-0">
                Saldo pronta entrega: {{ getSaldoProduto(prod, "imediato") }}
              </p>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="font-weight-bold subtitle-1">
            {{
              pedido_item.cliente.socio
                ? formatarMoeda(prod.valor_lista)
                : formatarMoeda(prod.valor_lista_nao_socio)
            }}
          </v-list-item-action>
        </v-list-item>-->
      </template>
      <v-data-table
        v-else
        :headers="headers"
        :items="produtosFiltrados()"
        no-data-text="Nenhum produto disponível para a venda"
        no-results-text="Nenhum produto localizado para a venda"
        :search="pesquisaProduto"
      >
        <template v-slot:[`item.valor`]="{ item }">
          {{
            pedido_item.cliente.socio
              ? formatarMoeda(item.valor_lista)
              : formatarMoeda(item.valor_lista_nao_socio)
          }}
        </template>
        <template v-slot:[`item.saldo`]="{ item }">
          {{ getSaldoProduto(item, "filial") }}
        </template>
        <template v-slot:[`item.saldo_imediato`]="{ item }">
          {{ getSaldoProduto(item, "imediato") }}
        </template>
        <template v-slot:[`item.selecionar`]="{ item }">
          <dialog-adicionar-produto-inumos :produto="item" />
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { formatMoeda } from "@/global";
import { mapActions, mapMutations, mapState } from "vuex";
import DialogAdicionarProdutoInumos from "../dialogs/DialogAdicionarProdutoInumos.vue";

export default {
  components: { DialogAdicionarProdutoInumos },
  computed: {
    ...mapState("insumos", [
      "produtosDisponiveis",
      "pedido_item",
      "lista_itens",
      "pedidosOffline",
      "pesquisaProduto",
    ]),
    pesquisaModel: {
      get: function () {
        return this.pesquisaProduto;
      },
      set: function (value) {
        this.setPesquisaProduto(value);
      },
    },
  },
  data: () => ({
    loading: true,
    headers: [
      { text: "Gp", value: "grupo" },
      { text: "Sgp", value: "subgrupo" },
      { text: "Item", value: "item" },
      { text: "Produto", value: "descricao" },
      { text: "Embalagem", value: "embalagem" },
      { text: "Valor Lista", value: "valor" },
      { text: "Saldo", value: "saldo" },
      { text: "Saldo Pronta Entrega", value: "saldo_imediato" },
      { text: "", value: "selecionar" },
    ],
  }),
  methods: {
    ...mapActions("insumos", ["getPedidosOffline"]),
    ...mapMutations("insumos", ["setListaItens","setPesquisaProduto"]),
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    produtosFiltrados() {
      var produtos = this.produtosDisponiveis.filter(
        (p) =>
          p.estoque.findIndex(
            (e) => e.filial == this.pedido_item.filialSelecionada.filial
          ) >= 0 && this.lista_itens.findIndex((i) => i.id == p.id) < 0
      );

      if (this.lista_itens.length > 0) {
        if (this.lista_itens[0].tem_remessa) {
          produtos = produtos.filter(
            (p) =>
              p.estoque.findIndex(
                (e) =>
                  e.filial == this.pedido_item.filialSelecionada.filial &&
                  e.saldo_imediato > 0
              ) >= 0
          );
        }
      }

      if (this.pedido_item.culturaSelecionada) {
        produtos = produtos.filter(
          (p) =>
            this.pedido_item.culturaSelecionada.gruposrestricao.findIndex(
              (gr) => gr.grupo == p.grupo
            ) < 0
        );
      }

      /*if (this.isMobile()) {
        produtos = produtos.filter((p) =>
          p.descricao.toLowerCase().includes(this.pesquisaProduto.toLowerCase())
        );
      }*/

      return produtos;
    },
    getSaldoProduto(prod, tipo) {
      var saldoDisp = 0;
      var saldoFilial = 0;
      var saldoImediato = 0;

      if (tipo == "filial" || tipo == "") {
        saldoFilial = prod.estoque.find(
          (e) => e.filial == this.pedido_item.filialSelecionada.filial
        ).saldo;
      }

      if (tipo == "imediato" || tipo == "") {
        saldoImediato = prod.estoque.find(
          (e) => e.filial == this.pedido_item.filialSelecionada.filial
        ).saldo_imediato;
      }

      saldoDisp = saldoFilial + saldoImediato;

      this.pedidosOffline.forEach((p) => {
        p.filter(
          (i) =>
            i.filial == this.pedido_item.filialSelecionada.filial &&
            i.grupo == prod.grupo &&
            i.subgrupo == prod.subgrupo &&
            i.item == prod.item
        ).forEach((pOff) => {
          saldoDisp -= pOff.quantidade;
        });
      });
      return saldoDisp;
    },
    selecionarProduto(prod) {
      if (this.getSaldoProduto(prod, "") <= 0) {
        this.$toasted.error("Produto não possui saldo para venda!");
        return;
      }
      this.$router.push({
        path: "/novo-pedido-insumos/selecionar-produtos/" + prod.id,
      });
    },
  },
  mounted() {
    this.setListaItens();
  },
  async created() {
    this.loading = true;
    await this.getPedidosOffline();
    this.loading = false;
  },
};
</script>

<style>
</style>